import { composeIO } from 'react-compose-io'
import { controleTitulosIO } from './ControleTitulos.IO'
import { ControleTitulosView } from './ControleTitulos.View'

export const ControleTitulos = composeIO(ControleTitulosView, controleTitulosIO)
